import type { Month } from "@ctrl/controller-rpc";

/**
 * Calendar months in order (January = index 0), matching the controller's
 * {@link Month} type used in graph date records and recurrence rules.
 */
export const MONTHS: readonly Month[] = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export type { Month };

/** Zero-based month index, or `-1` when `month` is not a known {@link Month}. */
export function monthIndex(month: Month): number {
  return MONTHS.indexOf(month);
}

/** The {@link Month} for a JS `Date` (local timezone). */
export function monthFromDate(date: Date): Month {
  return MONTHS[date.getMonth()] ?? "january";
}

/** Exact {@link Month} string (lowercase controller form). */
export function isMonth(value: unknown): value is Month {
  return typeof value === "string" && MONTHS.some((m) => m === value);
}

/**
 * Parse an unknown value as a {@link Month}. Accepts any casing
 * (`"March"`, `"march"`); rejects non-strings and unknown names.
 */
export function parseMonth(value: unknown): Month | undefined {
  if (typeof value !== "string") return undefined;
  const normalized = value.toLowerCase();
  return MONTHS.find((candidate) => candidate === normalized);
}
